import React, { useEffect, useState } from "react";
import './style.scss';
import axios from "axios";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import { getToken } from "../../auth/authConfig";

const UserRegistration = () => {
  // State to manage form inputs
  const [isLoading, setIsloading] = useState(false);
  const [issuccess, setsuccess] = useState(false);
  const [iserror, seterror] = useState(false);
  const [iserrorEmail, setiserrorEmail] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");

  const [formData, setFormData] = useState({
    Email: "",
    Role: "",
    Company:"Mars"
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsloading(true)
    const token = await getToken();

    const data = {
      email: formData.Email,
      userGroupId: parseInt(formData.Role),
      company:formData.Company
    };
    const url = `${process.env.REACT_APP_SERVER_URL}/api/user/registerUserV2`
    const header = {
      headers: {
        "oidc-token": token,
      },
    };
 
    axios
    .post(url, data, header)

    .then(function (response) {
      if (response.status === 201) {
        // console.log(response);
        setIsloading(false);
        setsuccess(true)
        handleReset()
        setTimeout(() => {
          setsuccess(false)
        }, 5000);
        
      }
   
    })
    .catch(function (error) {
      console.log(error);
      if(error.status === 409){
        setIsloading(false);
        seterrorMessage("User Already Exists")
        seterror(true)
        handleReset()
        setTimeout(() => {
          seterror(false)
          seterrorMessage("")
        }, 5000);
      }
      setIsloading(false);
      seterror(true)
      setTimeout(() => {
        seterror(false)
      }, 5000);
    });


  };

  // Handle form reset
  const handleReset = () => {
    setFormData({
      Email: "",
      Role: "",
      Company:"Mars"
    });
  };

  useEffect(() => {
    console.log("data", formData);
    if (formData.Role !== '104') {
        setFormData(prev => ({ ...prev, Company: 'Mars' }));
    }
}, [formData.Role]); // Only depend on formData.Role to avoid unnecessary re-renders


  return (
    <div className="userRegistration">
      <div id="form-userRegistration">
        <form onSubmit={handleSubmit}>
          <div className="form-component-container">
            <div className="input-box">
              <label className="input-label">Email</label>
              <input
                className="input-field"
                id="Email"
                name="Email"
                placeholder="Email"
                required
                type="email"
                value={formData.Email}
                onChange={handleChange}
              />
            </div>

            <div className="input-box">
              <label className="input-label">Role</label>
              <select
                className="input-field"
                id="Role"
                name="Role"
                required
                value={formData.Role}
                onChange={handleChange}
              >
                <option value="" disabled>Select Role</option>
                <option value={100}>Unit Admin</option>
                <option value={101}>Super Admin</option>
                <option value={103}>Mars Admin</option>
                <option value={104}>CB Admin (Lead auditor)</option>
                <option value={108}>CB Admin (Tech reviewer)</option>

              </select>
            </div>

              {(formData.Role === "104" || formData.Role === "108") && (
              <div className="input-box">
              <label className="input-label">Company</label>
              <select
                className="input-field"
                id="Company"
                name="Company"
                required
                value={formData.Company}
                onChange={handleChange}
              >
                <option value="Mars">Mars</option>
                <option value="Aays">Aays</option>
                <option value="LRQA">Llyod's Register Quality Assurance (LRQA)</option>
                <option value="BV">Bureau Veritas (BV)</option>
                <option value="BSI">British Standards Institution (BSI)</option>

                
              </select>
              </div>
              )}
           
          </div>
          <div className="button-container">
            <button type="button" className="reset_btn" onClick={handleReset}>Reset</button>
            {/* <button type="submit" className="submit_btn">Submit</button> */}

            <Button disabled={isLoading} className="submit_btn" type="submit">
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span style={{ paddingLeft: "10px" }}>Registering..</span>
                  </>
                ) : (
                  "Register"
                )}
              </Button>
          </div>
        </form>

        {iserrorEmail && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "0px" }}
              variant="danger"
            >
              <p className="mb-0">
                Please use only '@effem.com'
              </p>
            </Alert>
          </div>
        )}

      {iserror && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "0px" }}
              variant="danger"
            >
              <p className="mb-0">{errorMessage ?? 'Something went wrong, Please try after sometime'}</p>
            </Alert>
          </div>
        )}

      {issuccess && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "10px" }}
              variant="success"
            >
              <p className="mb-0">User Successfully Registered</p>
            </Alert>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserRegistration;
